/**
* Before and After Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Before and After Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'before-and-after-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      if ( $( '.before-and-after-slider' ).length ) {
        $( '.before-and-after-slider' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            pagination: false,
            arrows: true,
            speed: 800,
            perPage: 1,
            gap: '2rem',
          } );
          slider.mount();
        } );

        const liveRegion = $( '.ba-slider__live-region' );

        $( '.ba-slider__toggle' ).on( 'toggleAfter', ( event ) => {
          const target = $( event.target );
          if ( target.attr( 'aria-pressed' ) ) {
            target.attr( 'aria-pressed', false );
            liveRegion.text( 'Sensitive images are visible' );
          } else {
            liveRegion.text( 'Sensitive images are blurred' );
            target.attr( 'aria-press', true );
          }
        } );
      }
      function handleBagSliderMobile( event ) {
        $( '.before-and-after-slider__content' ).toggleClass( 'theme-bg-dark' );
      }

      const mobileSize = window.matchMedia( '(min-width: 1024px)' );
      mobileSize.addEventListener( 'change', handleBagSliderMobile );
      handleBagSliderMobile();
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'before-and-after-slider', COMPONENT );
} )( app );
